import clsx from "clsx";
import { guideSteps } from "hooks/useOnboarding";

export const ButtonAdder = ({ oneColMode = false, setIsButtonAdderOpen }) => {
  const wrapperSize = oneColMode ? "w-64 h-56" : "w-32 h-36 md:w-64 md:h-56";
  const buttonSize = oneColMode ? "w-24 h-24" : "w-14 h-14 md:w-24 md:h-24";

  return (
    <div
      className={clsx(
        guideSteps.NEW_BUTTON,
        guideSteps.BUTTON,
        guideSteps.BUTTON_QUESTION,
        "bg-white p-0 sm:p-4 border-4 rounded-3xl border-dashed flex flex-col justify-start items-center cursor-pointer"
      )}
      onClick={() => setIsButtonAdderOpen(true)}
    >
      <div
        className={`flex flex-col justify-center items-center ${wrapperSize} text-gray-400`}
      >
        <button
          className={`bg-gray-200 hover:bg-gray-300 ${buttonSize} rounded-full text-white font-extrabold text-3xl`}
        >
          +
        </button>
        <div className={oneColMode ? "tex-xl" : "text-xs sm:text-xl"}>
          Add a new button
        </div>
      </div>
    </div>
  );
};
